import { Component } from '@angular/core';

import { SkipFinanceService } from '@app/configure/services/skip-finance.service';
import { ConfigureService } from '@app/configure/services/configure.service';
import { ModalService } from '@app/core/services/modal.service';

import { ModalAction } from '@app/core/models/modal-action.model';
import { Modal } from '@app/core/models/modal.model';

@Component({
	selector: 'cng-finance-skip-modal',
	templateUrl: './finance-skip.component.html',
})
export class ConfigureFinanceSkipModalComponent {
	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {ModalService} modal_service
	 * @param {ConfigureService} configure_service
	 * @param {SkipFinanceService} skip_finance_service
	 */
	constructor(
		private modal_service: ModalService,
		private configure_service: ConfigureService,
		private skip_finance_service: SkipFinanceService
	) {
		this.constructModal();
	}

	/**
	 * Constructs modal.
	 */
	constructModal(): void {
		this.modal_service.setConfig(
			new Modal({
				name: 'finance_skip_modal',
				title: 'Are you sure?',
				actions: [
					new ModalAction({
						id: 'cancel',
						name: 'Cancel',
						large: true,
						click: (): void => {
							this.modal_service.close();
						},
					}),
					new ModalAction({
						id: 'continue',
						name: 'Continue',
						bias: 'positive',
						large: true,
						showLoading: true,
						click: (): void => {
							this.modal_service.close().then(() => {
								// this.skip_finance_service.dispose();
								this.configure_service.navigateToStep('reserve');
							});
						},
					}),
				],
			})
		);
	}
}
